// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"c2a194baf75a1e0a","2927":"a048fb0ad549550e","4417":"0f626cf3ec6a899f","9777":"96aa7a5e96054b30"}[chunkId] + ".js";
};